export const TextBlocksHeaderOptions = [
  { heading: 'Members', path: '/text-blocks/members' },
  { heading: 'Client Administrators', path: '/text-blocks/client-admin' },
  { heading: 'Listeners', path: '/text-blocks/listener-faq' },
  { heading: 'Versioned Records', path: '/text-blocks/versioned-records' },
  { heading: 'AI Prompts', path: '/text-blocks/ai-prompts' },
  { heading: 'Fi concierge', path: '/text-blocks/fi-concierge' },
  { heading: 'Peersona Crisis Defaults', path: '/text-blocks/peersona-crisis-defaults' },
];

// Type for app settings with system properties
interface AppSettings {
  system?: {
    [key: string]: string | number | boolean;
  };
}

/**
 * Creates default values for a given set of keys from the app settings.
 * @param keys - The keys to create default values for.
 * @param appSettings - The app settings to use to create the default values.
 * @returns The default values for the given keys.
 */
export const createDefaultValues = <T extends readonly string[]>(keys: T, appSettings?: AppSettings) => {
  if (!appSettings?.system) {
    return Object.fromEntries(keys.map((key) => [key, '']));
  }

  return Object.fromEntries(keys.map((key) => [key, appSettings.system?.[key] || '']));
};
